import useSwitch from './hooks/useSwitch'
import Switch from '../control/Switch'

type SwitchPlaygroundType = ReturnType<typeof useSwitch>

const SwitchPlaygroundView = (props: SwitchPlaygroundType) => {
    const { onChange, value } = props

    return (
        <div>
            <Switch labelOn={'เปิด'} labelOff={'ปิด'} checked={value} onChange={onChange} width={60} />
            <Switch label={'switch'} checked={value} onChange={onChange} />
            <Switch label={'switch (required)'} checked={value} onChange={onChange} required />
            <Switch label={'switch (disabled)'} checked={value} onChange={onChange} disabled />
        </div>
    )
}

//Controller
const SwitchPlayground = () => {
    const switchModel = useSwitch()
    return <SwitchPlaygroundView {...switchModel} />
}

export default SwitchPlayground
